import { Cesium } from 'senf-atomic-design-system';

function MainPage() {


  return <Cesium/>;
}

export default MainPage; 